import React from 'react'
import Radio from '@material-ui/core/Radio'
import { useDispatch, useSelector } from 'react-redux'

import styles from './RadioSelect.module.scss'
import * as SettingsAction from './../../SettingsAction'
import { ReactComponent as PersianLanguage } from '../../../../assets/svgs/farsi_language.svg'
import { ReactComponent as EnglishLanguage } from '../../../../assets/svgs/english_language.svg'
import I18n from 'i18n-js'


const LanguageRadioSelect = (props) => {
	const { language } = useSelector(state => state.SettingsReducer)
	const dispatch = useDispatch()



	const handleChange = async (value) => {
		await dispatch(SettingsAction.setLanguage(value));
		setTimeout(()=>{
			window.location.reload(true);
		},200)
		props.handleClose();

	}
	return (
		<div>
			<div className={styles.row} onClick={()=>{handleChange('fa')}}>
				<div className={styles.icon}>
					<PersianLanguage width={24} height={24}/>
					<div className={styles.title}>
						<h5>{I18n.t('settings.radioSelect.faLanguage')}</h5>
					</div>
				</div>
				<Radio
					checked={language === 'fa'}
					onChange={()=>{handleChange('fa')}}
					value="fa"
					color="primary"
					name="radio-button-demo"
					// inputProps={{ 'aria-label': 'E' }}
					// size="small"
				/>

			</div>
			<div className={styles.endRow} onClick={()=>{handleChange('en')}}>
				<div className={styles.icon}>
					<EnglishLanguage width={24} height={24}/>
					<div className={styles.title}>
						<h5>{I18n.t('settings.radioSelect.enLanguage')}</h5>

					</div>
				</div>
				<Radio
					checked={language === 'en'}
					onChange={()=>{handleChange('en')}}
					value="en"
					color="primary"
					name="radio-button-demo"
					// inputProps={{ 'aria-label': 'A' }}
					// size="small"
				/>

			</div>
		</div>
	)
}

export default LanguageRadioSelect
